"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/MessageTemplates/SaveAsTemplateHost.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _SaveAsTemplateModal = require('./SaveAsTemplateModal'); var _SaveAsTemplateModal2 = _interopRequireDefault(_SaveAsTemplateModal);







const OpenSaveAsTemplate = _react.createContext(null)

/* Messages call this to open "Save as template". It is null outside a staff
 * conversation, and the menu item is hidden then. */
 const useOpenSaveAsTemplate = () => _react.useContext.call(void 0, OpenSaveAsTemplate); exports.useOpenSaveAsTemplate = useOpenSaveAsTemplate

/* Renders the editor next to `children`, not inside them, so it stays out of
 * the conversation's file drop zone and message-row handlers. */
const SaveAsTemplateHost = ({ children }) => {
  const [request, setRequest] = _react.useState(null)
  const close = _react.useCallback.call(void 0, () => setRequest(null), [])
  return (
    _react2.default.createElement(OpenSaveAsTemplate.Provider, { value: setRequest, __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
      ,  children 
      ,  request && _react2.default.createElement(_SaveAsTemplateModal2.default, { ...request, onClose: close, __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}} ) 
    )
  )
}

exports. default = SaveAsTemplateHost
